var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g4, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _g5, _path125, _path126, _path127, _g6, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 428,
    viewBox: "0 0 676 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_4919)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.255 305.431C676.505 281.933 678.196 256.917 672.987 232.874C664.862 195.262 638.698 149.727 563.2 130.084C420.272 92.881 370.646 -15.9052 236.931 18.7475C236.931 18.7475 165.185 31.8104 131.227 150.72C97.2684 269.629 -35.7856 271.654 10.0106 375.184C17.4943 392.101 37.6711 410.576 66.6144 428L608.841 426.17C646.318 381.044 657.981 342.011 669.255 305.411V305.431Z",
    fill: "#71B9A1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M541.313 220.376H520.961V198.085C520.961 186.891 513.186 177.546 502.748 175.113V147.449H495.264V174.587C483.251 175.678 473.843 185.762 473.843 198.085V221.038H453.608V246.599H452.248V294.12L415.471 293.847V237.06H373.329V278.682H343.763V319.116H308.017V426.131H426.764H452.267H601.163V291.18H541.294L541.352 220.376H541.313Z",
    fill: "#71B9A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.527 279.207V226.002H141.432V197.559H148.916V226.002H167.265V279.207H187.85V311.076H220.662V202.504H289.142V426.131H244.512H225.288H176.906H154.572H96.1993V279.207H121.527Z",
    fill: "#71B9A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.672 425.586L183.535 425.839C171.716 425.839 162.114 416.261 162.114 404.424L517.074 404.152C517.074 415.988 507.51 425.605 495.692 425.605L495.672 425.586Z",
    fill: "#044742"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.672 418.208L183.535 418.461C174.302 418.461 166.468 412.62 163.455 404.424H162.133C162.133 416.261 171.736 425.859 183.554 425.839L495.692 425.586C507.51 425.586 517.093 415.969 517.074 404.132H515.752C512.758 412.328 504.925 418.208 495.692 418.208H495.672Z",
    fill: "#71B9A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.761 411.433L319.427 411.472C315.461 411.472 312.254 408.26 312.254 404.308L366.914 404.269C366.914 408.24 363.707 411.452 359.761 411.452V411.433Z",
    fill: "#1B232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M498.802 404.152L180.386 404.405L180.23 211.907C180.23 200.869 189.152 191.914 200.174 191.894L478.664 191.68C489.685 191.68 498.627 200.616 498.646 211.654L498.802 404.132V404.152Z",
    fill: "#044742"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M482.143 208.422H196.889V387.643H482.143V208.422Z",
    fill: "#1B232A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.941 208.461L196.889 303.815L196.947 387.76H197.161L375.972 208.403L291.941 208.461Z",
    fill: "#71B9A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M412.594 208.384L233.782 387.741L275.905 387.702L454.716 208.325L412.594 208.384Z",
    fill: "#71B9A1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M482.124 290.304L381.493 387.604L448.652 387.565L482.182 353.925L482.124 290.304Z",
    fill: "#71B9A1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M291.941 208.461L196.889 303.815L196.947 387.76H197.161L375.972 208.403L291.941 208.461Z",
    fill: "#5571E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M412.594 208.384L233.782 387.741L275.905 387.702L454.716 208.325L412.594 208.384Z",
    fill: "#5571E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M482.124 290.304L381.493 387.604L448.652 387.565L482.182 353.925L482.124 290.304Z",
    fill: "#5571E9"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M498.802 284.97H180.23V320.187H498.802V284.97Z",
    fill: "#5CFFBD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 180,
    y: 284,
    width: 319,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M498.802 284.97H180.23V320.187H498.802V284.97Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_4919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.981 332.549H192.554L216.152 278.487H243.56L219.981 332.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.432 332.549H251.024L274.603 278.487H302.03L278.432 332.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.882 332.549H309.474L333.072 278.487H360.48L336.882 332.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.333 332.549H367.925L391.523 278.487H418.931L395.333 332.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.783 332.549H426.375L449.973 278.487H477.381L453.783 332.549Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.65 224.152L148.43 224.386L144.775 223.237C143.104 222.712 141.276 223.335 140.285 224.795L139.818 225.476L158.032 235.541L161.55 227.988L154.63 224.152H154.65Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.051 235.716L139.702 225.574L140.343 224.406C140.479 224.172 140.752 224.094 140.985 224.211L158.926 234.139L158.051 235.716Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.57 228.007L166.371 219.655L161.57 211.051L154.65 224.152L161.57 228.007Z",
    fill: "#EB8175"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.241 180.058C199.241 180.058 173.291 172.602 170.803 179.61C168.295 186.619 153.172 217.67 153.172 217.67L164.466 223.568L181.416 194.094L204.217 192.108L199.26 180.058H199.241Z",
    fill: "#14103D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.151 233.614L173.077 236.845L169.326 237.605C167.596 237.955 166.313 239.396 166.157 241.148L166.079 241.966L186.878 241.927L186.295 233.594H178.151V233.614Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M186.975 242.082L166.021 242.121V240.797C166.021 240.544 166.235 240.33 166.488 240.33L186.975 240.291V242.102",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.315 233.633L186.975 219.655L178.695 218.721L178.151 233.614L186.315 233.633Z",
    fill: "#EB8175"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.759 178.851L178.306 179.961C178.306 179.961 174.788 180.155 175.021 188.39C175.254 196.644 175.235 229.818 175.235 229.818L186.975 230.226L189.23 195.476L213.703 195.165C218.854 195.106 223.655 192.147 225.696 187.397C226.474 185.587 226.843 183.543 226.377 181.401L202.759 178.831V178.851Z",
    fill: "#231C61"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.55 173.925C179.55 176.242 177.976 176.593 175.662 176.612C173.349 176.612 171.153 176.281 171.153 173.945C171.153 171.628 173.019 169.74 175.351 169.72C177.665 169.72 179.55 171.589 179.57 173.925H179.55Z",
    fill: "#E1AD9D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.505 176.301H177.645C176.382 176.301 175.332 175.269 175.332 174.003C175.332 172.738 176.362 171.687 177.626 171.687H182.485C183.749 171.687 184.798 172.718 184.798 173.984C184.798 175.249 183.768 176.301 182.505 176.301Z",
    fill: "#E1AD9D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M182.31 176.787L180.697 168.825L200.66 166.645L204.645 143.283C205.053 141.161 208.124 138.533 210.243 138.922L209.64 138.747C211.759 139.156 213.703 141.609 213.314 143.731L209.426 171.687C209.135 173.186 208.007 174.393 206.511 174.763L182.33 176.787H182.31Z",
    fill: "#C8C6F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222.197 139.448C222.606 139.487 223.014 139.565 223.403 139.721L223.597 139.798C227.018 141.142 229.351 144.821 229.506 148.267L226.377 181.421C205.694 181.245 202.759 178.851 202.759 178.851L204.412 144.938C204.664 141.745 206.122 138.728 209.757 138.436L222.197 139.448Z",
    fill: "#D8D7FD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M199.416 176.515C199.571 178.831 198.036 179.279 195.723 179.454C193.41 179.61 191.194 179.415 191.038 177.099C190.883 174.782 192.632 172.777 194.945 172.621C197.258 172.465 199.26 174.218 199.416 176.534V176.515Z",
    fill: "#EB8175"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M202.507 178.695L197.666 179.026C196.403 179.104 195.295 178.15 195.198 176.885C195.12 175.619 196.073 174.51 197.336 174.412L202.176 174.081C203.44 174.003 204.548 174.957 204.625 176.223C204.703 177.488 203.751 178.598 202.487 178.695H202.507Z",
    fill: "#EB8175"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.351 179.201L200.213 171.375L221.964 167.871L220.72 147.605C220.973 145.464 223.325 143.05 225.463 143.303C227.601 143.556 229.72 145.892 229.448 148.033L231.022 172.31C230.828 173.828 229.778 175.113 228.32 175.561L202.351 179.182V179.201Z",
    fill: "#D8D7FD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M164.719 152.277L188.453 154.516C189.23 154.594 189.852 155.197 189.95 155.976L192.438 177.41C192.554 178.461 191.68 179.357 190.63 179.26L166.488 176.982C165.691 176.904 165.069 176.281 164.991 175.483L162.892 154.088C162.794 153.056 163.669 152.18 164.699 152.277H164.719Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.358 152.16L187.092 154.399C187.87 154.477 188.492 155.081 188.589 155.859L191.077 177.293C191.194 178.345 190.319 179.24 189.269 179.143L165.127 176.865C164.33 176.787 163.708 176.164 163.63 175.366L161.531 153.971C161.434 152.939 162.308 152.063 163.339 152.16H163.358Z",
    fill: "#37424A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M191.777 177.566L207.988 179.104C208.474 179.143 208.843 179.591 208.805 180.077C208.766 180.564 208.319 180.934 207.833 180.895L190.63 179.338L191.777 177.566Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M176.945 165.146C176.809 166.567 175.546 167.618 174.107 167.501C172.688 167.365 171.639 166.099 171.755 164.659C171.891 163.238 173.155 162.186 174.593 162.303C176.012 162.439 177.062 163.705 176.945 165.146Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.981 152.277L220.506 167.501L200.213 171.375L218.096 165.768L219.981 152.277Z",
    fill: "#C8C6F2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M209.213 137.423L210.573 141.064C211.059 142.388 212.284 143.283 213.683 143.38C216.346 143.556 218.251 140.869 217.202 138.416L214.83 132.809L209.232 137.404L209.213 137.423Z",
    fill: "#EB8175"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.418 140.674C210.418 140.674 217.105 139.409 216.113 133.549C215.122 127.689 208.843 132.264 208.843 132.264L209.465 138.105L210.418 140.674Z",
    fill: "#E16C5F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.116 123.153C197.666 128.41 199.921 134.659 205.17 137.112C210.418 139.565 216.658 137.307 219.107 132.05C221.556 126.794 219.301 120.545 214.053 118.092C208.805 115.639 202.565 117.897 200.116 123.153Z",
    fill: "#EB8175"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_201_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 199,
    y: 117,
    width: 22,
    height: 22
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.116 123.153C197.666 128.41 199.921 134.659 205.17 137.112C210.418 139.565 216.658 137.307 219.107 132.05C221.556 126.794 219.301 120.545 214.053 118.092C208.805 115.639 202.565 117.897 200.116 123.153Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_201_4919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.489 129.675C213.489 129.675 211.837 138.085 218.018 138.28C224.2 138.455 220.837 122.492 220.837 122.492L211.059 112.641L196.111 116.32L197.589 125.996C197.589 125.996 199.96 127.261 212.828 125.139L213.509 129.656L213.489 129.675Z",
    fill: "#231C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.386 123.095L212.303 130.279L216.541 125.606L207.386 123.095Z",
    fill: "#231C61"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M211.856 127.728C211.156 129.208 211.798 130.979 213.295 131.68C214.772 132.381 216.541 131.739 217.241 130.24C217.94 128.76 217.299 126.989 215.802 126.288C214.325 125.587 212.556 126.229 211.856 127.728Z",
    fill: "#EB8175"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M198.075 125.859C198.075 125.859 195.8 117.586 201.165 112.466C205.578 108.241 212.809 108.514 216.735 113.205C218.582 115.405 220.059 118.734 220.195 123.718L198.075 125.879V125.859Z",
    fill: "#FFBB10"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M199.202 125.704L199.144 120.545C199.144 119.24 200.155 118.15 201.457 118.092C202.74 118.033 203.867 118.987 203.984 120.272L204.509 125.431",
    stroke: "white",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M220.195 123.699L196.131 126.015",
    stroke: "white",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M439.302 402.964L444.686 408.201L438.544 411.511L433.276 406.352L439.302 402.964Z",
    fill: "#EB8175"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M401.32 363.873L404.916 379.856C405.635 383.049 407.034 386.125 409.017 388.948L432.751 410.304L442.14 402.653L421.885 381.16L414.46 352.815L401.32 363.873Z",
    fill: "#14103D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M438.369 411.374L436.425 417.585L434.209 420.68C433.179 422.101 433.218 424.029 434.306 425.411L434.812 426.053L449.954 411.92L443.909 406.254L438.388 411.374H438.369Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M450.09 411.958L434.831 426.209L433.606 424.885L448.865 410.654L450.09 411.958Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M387.402 412.698L385.38 419.454L378.441 417.585L380.463 410.946L387.402 412.698Z",
    fill: "#EB8175"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M396.732 346.04L377.275 411.939L389.56 415.015L400.523 381.978L413.974 360.369C414.654 359.395 415.335 358.403 415.898 357.351C416.967 355.366 417.453 353.224 417.434 351.063L417.395 346.78L396.752 346.06L396.732 346.04Z",
    fill: "#231C61"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M378.83 416.942L372.687 419.22L368.858 419.356C367.089 419.415 365.592 420.641 365.145 422.335L364.932 423.133L385.497 426.52L386.294 418.188L378.81 416.942H378.83Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M385.575 426.657L364.854 423.25L365.145 421.459L385.866 424.885L385.575 426.657Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M369.558 279.11L361.685 291.414L365.456 294.12L373.601 281.115L369.558 279.11Z",
    fill: "#334FBE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M359.333 258.747C359.333 258.747 362.968 273.99 381.396 279.986C381.92 280.161 382.329 280.609 382.406 281.154C382.64 282.926 382.64 286.741 378.577 287.871C378.188 287.968 377.761 287.89 377.43 287.695C374.612 285.924 360.752 277.825 347.301 280.161L359.353 258.766L359.333 258.747Z",
    fill: "#4265D1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M359.333 258.747C359.333 258.747 355.951 273.951 347.282 280.142C347.282 280.142 348.506 266.806 359.333 258.747Z",
    fill: "#334FBE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M359.12 290.616C358.556 293.419 360.85 296.826 363.649 297.39C366.448 297.955 369.169 296.164 369.733 293.361C370.296 290.557 368.003 287.15 365.204 286.586C362.405 286.021 359.683 287.812 359.12 290.616Z",
    fill: "#EB8175"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M373.912 298.812L368.45 293.107L364.893 297.507L373.912 304.126",
    fill: "#EB8175"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M373.037 293.536L367.264 302.121L383.028 316.566C383.981 316.839 384.992 316.936 385.983 316.858L406.801 314.152C410.086 313.996 412.613 311.213 412.458 307.922C412.302 304.632 412.924 299.882 409.659 300.038L385.478 305.022L373.037 293.536Z",
    fill: "#C8C6F2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M419.728 313.237C420.291 308.682 418.212 304.185 414.363 301.693C412.633 300.583 410.903 299.824 409.678 300.038C405.538 300.739 401.261 302.627 399.434 308.234C396.324 317.773 395.449 345.982 395.449 345.982L417.764 346.741L419.747 313.218L419.728 313.237Z",
    fill: "#D8D7FD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M411.486 313.957L418.192 338.643L419.553 317.695L411.486 313.957Z",
    fill: "#C8C6F2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M438.835 362.666C440.935 360.739 441.09 356.631 439.185 354.528C437.261 352.406 433.995 352.27 431.896 354.178C429.777 356.105 429.641 360.213 431.546 362.316C433.47 364.418 436.736 364.574 438.835 362.666Z",
    fill: "#EB8175"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M428.708 345.087L432.771 355.132L438.233 353.691L434.851 343.023",
    fill: "#EB8175"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M428.961 352.835L440.138 350.382L432.557 324.431C432.285 323.477 431.818 322.562 431.216 321.764L417.298 304.418C415.412 301.712 412.244 302.199 409.562 304.087C406.86 305.976 406.218 309.675 408.084 312.381L421.477 328.519L428.941 352.854L428.961 352.835Z",
    fill: "#D8D7FD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M404.449 296.651L404.877 300.564C405.032 301.985 405.985 303.172 407.346 303.601C409.911 304.438 412.438 302.277 412.03 299.61L411.097 293.516L404.469 296.631L404.449 296.651Z",
    fill: "#EB8175"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M404.819 300.135C404.819 300.135 411.7 299.902 412.205 293.925C412.691 287.948 405.382 291.511 405.382 291.511L404.527 297.39L404.819 300.135Z",
    fill: "#E16C5F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M399.065 280.395C395.352 284.931 396.013 291.628 400.542 295.346C405.071 299.065 411.758 298.403 415.471 293.867C419.183 289.331 418.523 282.634 413.993 278.915C409.464 275.197 402.778 275.859 399.065 280.395Z",
    fill: "#EB8175"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_201_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 396,
    y: 276,
    width: 22,
    height: 22
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M399.065 280.395C395.352 284.931 396.013 291.628 400.542 295.346C405.071 299.065 411.758 298.403 415.471 293.867C419.183 289.331 418.523 282.634 413.993 278.915C409.464 275.197 402.778 275.859 399.065 280.395Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_201_4919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.572 290.129C410.572 290.129 406.86 297.974 412.866 299.688C418.872 301.401 419.553 284.912 419.553 284.912L412.419 272.822L396.849 272.705L395.897 282.575C395.897 282.575 397.918 284.405 411.039 285.534L410.572 290.129Z",
    fill: "#231C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.218 282.147L409.251 290.44L414.557 286.897L406.218 282.147Z",
    fill: "#231C61"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M409.445 287.793C408.395 289.078 408.59 290.966 409.873 292.017C411.156 293.069 413.041 292.874 414.091 291.589C415.14 290.304 414.946 288.416 413.663 287.364C412.38 286.313 410.495 286.508 409.445 287.793Z",
    fill: "#EB8175"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M396.324 283.451C396.324 283.451 395.799 274.788 402.175 270.836C407.423 267.585 414.518 269.357 417.434 274.827C418.795 277.397 419.572 280.979 418.678 285.943L396.344 283.451H396.324Z",
    fill: "#FFBB10"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M397.49 283.549L398.501 278.429C398.754 277.124 399.998 276.268 401.3 276.482C402.583 276.696 403.497 277.884 403.341 279.169L402.778 284.386",
    stroke: "white",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M418.678 285.924L394.38 283.198",
    stroke: "white",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 348.922L541.838 373.743",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 322.387L541.838 347.209",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 295.852L541.838 320.693",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 269.337L541.838 294.159",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 242.803L541.838 267.624",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 216.287L541.838 241.109",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 189.753L541.838 214.574",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 163.238L541.838 188.059",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 136.703L541.838 161.524",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 110.168L541.838 134.99",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 83.6532L541.838 108.475",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 347.209H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 320.693H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 294.159H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 267.624H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 241.109H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 214.574H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 188.059H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 161.524H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 134.99H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 108.475H566.991",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M541.838 380.927V87.8972",
    stroke: "#044742",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M566.991 380.927V87.8972",
    stroke: "#044742",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M578.945 373.743H528.873V425.839H578.945V373.743Z",
    fill: "#1B232A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M540.886 38.2737H567.049C571.656 38.2737 575.408 42.031 575.408 46.6449V79.526C575.408 84.1399 571.656 87.8972 567.049 87.8972H540.886C536.279 87.8972 532.527 84.1399 532.527 79.526V46.6449C532.527 42.031 536.279 38.2737 540.886 38.2737Z",
    fill: "#1B232A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M553.268 73.4521H536.415V50.2464H553.268C556.766 50.2464 559.604 53.0887 559.604 56.5929V67.125C559.604 70.6292 556.766 73.4715 553.268 73.4715V73.4521Z",
    fill: "#1B232A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M540.886 38.2737H567.049C571.656 38.2737 575.408 42.031 575.408 46.6449V79.526C575.408 84.1399 571.656 87.8972 567.049 87.8972H540.886C536.279 87.8972 532.527 84.1399 532.527 79.526V46.6449C532.527 42.031 536.279 38.2737 540.886 38.2737Z",
    fill: "#71B9A1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M553.268 73.4521H536.415V50.2464H553.268C556.766 50.2464 559.604 53.0887 559.604 56.5929V67.125C559.604 70.6292 556.766 73.4715 553.268 73.4715V73.4521Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M375.972 90.6032L396.071 149.104",
    stroke: "#1B232A",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M361.977 83.6532L322.751 136.703",
    stroke: "#1B232A",
    strokeWidth: 2.16,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M370.238 95.5286C379.524 95.5286 387.052 87.9892 387.052 78.6889C387.052 69.3886 379.524 61.8493 370.238 61.8493C360.952 61.8493 353.424 69.3886 353.424 78.6889C353.424 87.9892 360.952 95.5286 370.238 95.5286Z",
    fill: "#1B232A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M382.115 78.6889C382.115 85.269 376.789 90.6032 370.219 90.6032C363.649 90.6032 358.323 85.269 358.323 78.6889C358.323 72.1088 363.649 66.7746 370.219 66.7746C376.789 66.7746 382.115 72.1088 382.115 78.6889Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M436.172 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M404.196 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M468.012 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M503.409 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M536.434 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M570.665 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M604.293 2.56975V38.2737",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M402.544 38.2737L436.172 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M436.172 38.2737L469.781 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M469.781 38.2737L503.409 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M503.409 38.2737L537.037 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M537.037 38.2737L570.665 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M570.665 38.2737L604.293 2.56975",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M370.238 38.2737H644.374L607.461 2.56975H398.598L370.238 38.2737Z",
    stroke: "#044742",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M370.238 38.2737V78.6889",
    stroke: "#1B232A",
    strokeWidth: 2.65,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M404.189 124.851L305.426 136.996L318.001 239.561L416.763 227.416L404.189 124.851Z",
    fill: "#71B9A1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.868 141.512C386.955 141.648 385.905 141.804 384.797 141.979C387.246 141.706 383.592 142.212 383.009 142.271C382.29 142.388 381.59 142.504 380.968 142.621C378.596 143.05 377.43 143.4 382.231 142.952L385.808 142.504C386.294 142.504 386.022 142.602 385.75 142.699C387.616 142.485 387.46 142.543 385.516 142.777C385.264 142.874 385.341 142.933 387.052 142.777C387.732 142.699 388.296 142.641 388.918 142.582C389.598 142.504 390.318 142.407 391.134 142.31C391.542 145.639 398.579 204.198 399.726 213.64C397.432 213.932 395.236 214.224 392.961 214.516C383.417 215.801 387.052 215.762 396.635 214.73V214.847C387.091 215.976 391.892 215.664 390.726 215.957C394.05 215.567 397.335 215.178 401.125 214.73C400.95 213.134 400.756 211.44 400.562 209.571C400.406 208.364 392.223 141.083 392.203 140.966C390.843 141.142 389.501 141.317 387.888 141.531L387.868 141.512Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.55 149.688V149.571C335.094 148.442 330.293 148.754 331.459 148.462C328.135 148.851 324.85 149.24 321.06 149.688C321.235 151.284 321.429 152.978 321.623 154.847C321.779 156.054 329.962 223.335 329.982 223.452C331.342 223.276 332.684 223.101 334.297 222.887C335.211 222.751 336.26 222.595 337.368 222.42C334.919 222.692 338.573 222.186 339.156 222.128C339.876 222.011 340.575 221.894 341.197 221.777C343.569 221.349 344.735 220.999 339.934 221.446L336.357 221.894C335.871 221.894 336.144 221.797 336.416 221.7C334.55 221.914 334.705 221.855 336.649 221.622C336.902 221.524 336.824 221.466 335.113 221.622C334.433 221.699 333.869 221.758 333.247 221.816C332.567 221.894 331.848 221.992 331.031 222.089C330.623 218.76 323.587 160.201 322.44 150.759C324.733 150.467 326.93 150.175 329.204 149.883C338.748 148.598 335.113 148.637 325.53 149.669L325.55 149.688Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358.556 208.13L376.108 185.82L355.173 179.649L358.556 208.13Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.61 156.288L346.057 178.598L366.992 184.769L363.61 156.288Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 421.011L244.473 371.329C245.387 368.954 248.73 368.954 249.644 371.329L268.829 421.011H225.268H225.288Z",
    fill: "#71B9A1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_201_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 369,
    width: 44,
    height: 53
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M225.288 421.011L244.473 371.329C245.387 368.954 248.73 368.954 249.644 371.329L268.829 421.011H225.268H225.288Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_201_4919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.814 382.017H229.739V392.569H263.814V382.017Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.419 401.952H227.873V412.504H266.419V401.952Z",
    fill: "#FAFAFA"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M272.581 421.011H221.789V425.197H272.581V421.011Z",
    fill: "#044742"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M503.953 421.167L523.138 371.485C524.052 369.11 527.395 369.11 528.309 371.485L547.494 421.167H503.934H503.953Z",
    fill: "#71B9A1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_201_4919",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 503,
    y: 369,
    width: 45,
    height: 53
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M503.953 421.167L523.138 371.485C524.052 369.11 527.395 369.11 528.309 371.485L547.494 421.167H503.934H503.953Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_201_4919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M542.479 382.173H508.404V392.724H542.479V382.173Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.084 402.108H506.538V412.659H545.084V402.108Z",
    fill: "#FAFAFA"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M551.227 421.167H500.435V425.352H551.227V421.167Z",
    fill: "#044742"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M160.454 343.86C163.696 322.059 148.678 301.755 126.91 298.508C105.143 295.262 84.8688 310.303 81.6272 332.104C78.3857 353.904 93.404 374.209 115.171 377.456C136.939 380.702 157.213 365.661 160.454 343.86Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M121.061 323.769V425.197",
    stroke: "#3D5AC4",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M105.568 325.833L121.061 343.237",
    stroke: "#3D5AC4",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M134.803 342.283C133.695 343.393 121.061 356.573 121.061 356.573",
    stroke: "#3D5AC4",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M121.061 323.769V425.197",
    stroke: "#1B232A",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M105.568 325.833L121.061 343.237",
    stroke: "#1B232A",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M134.803 342.283C133.695 343.393 121.061 356.573 121.061 356.573",
    stroke: "#1B232A",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10791 426.17H669.585",
    stroke: "#1B232A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_4919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 676,
    height: 428,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentImage);
export default __webpack_public_path__ + "static/media/DevelopmentImage.b9ce6a27c2ae67e7a98a793ee141a4ac.svg";
export { ForwardRef as ReactComponent };